import "core-js/modules/es.string.replace";
import { MSA_SEARCH_HASHES } from 'constants/msa-search-hashes';
export var buildCitcatUrlFromMsaAlias = function buildCitcatUrlFromMsaAlias(msaAlias) {
  return msaAlias ? "/venues/".concat(MSA_SEARCH_HASHES[msaAlias.replace(/\./g, '')]) : '/';
};
export var formatMsaNameFromAlias = function formatMsaNameFromAlias(msaAlias) {
  return msaAlias.replace(/\b[a-z]([a-z]$|)/g, function (x) {
    return x.toUpperCase();
  }).replace(/-/g, ' ');
};